<template>
 <div id="app" class="page">
    <app-header/>
    <router-view></router-view>
    <app-footer/>
  </div>
</template>

<script>
/* Header & Footer */
// import Header from './components/Header.vue';
// import Footer from './components/Footer.vue';

/* Components */
import Home from './components/Home.vue';

export default {
  components:{
    // 'header-app':Header,
    // 'footer-app':Footer,
    'home': Home    
  },
  data () {
    return {
      component: 'home',
    }
  }, 
}
</script>

<style>
body{
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue